module.exports = __webpack_public_path__ + "img/menu.c4bb3ec8.svg";